import { render, staticRenderFns } from "./Card-Article-Featured.vue?vue&type=template&id=d311fdca&"
import script from "./Card-Article-Featured.vue?vue&type=script&lang=js&"
export * from "./Card-Article-Featured.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports